import type { KPIRequest } from "@/types/kpiTypes.ts"

export const SPLKPIs: KPIRequest[] = [
  {
    $type: "basic",
    id: 10,
    location: 3,
    aggFunction: "Sum",
  },
  {
    $type: "calc",
    expression: "[10]",
    name: "Manure Trucked Daily Average",
    unit: "Gallons",
    location: 3,
    preAggregate: true,
    aggFunction: "Average",
  },
  {
    $type: "basic",
    id: 12,
    location: 3,
    aggFunction: "Sum",
  },
  {
    $type: "basic",
    id: 11,
    location: 3,
  },
  {
    $type: "calc",
    preAggregate: true,
    expression: "[10]/[11]",
    name: "Gallons/Load",
    unit: "Gallons",
    location: 3,
  },

  {
    $type: "basic",
    id: 350,
    location: 3,
  },
  {
    $type: "basic",
    id: 340,
    location: 3,
  },
  {
    $type: "basic",
    id: 300,
    location: 3,
    aggFunction: "Sum",
  },
  {
    $type: "basic",
    id: 310,
    location: 3,
    aggFunction: "Sum",
  },
  {
    $type: "basic",
    id: 320,
    location: 3,
    aggFunction: "Average",
  },
  {
    $type: "basic",
    id: 330,
    location: 3,
    aggFunction: "Average",
  },
]
